import { color } from '@upstox/upstox-ui';

export const hoverCellContainer: CSSFunction<{
  isCall: boolean;
}> = ({ cssProps }) => ({
  position: 'sticky',
  ...(cssProps.isCall
    ? {
        right: 0,
      }
    : {
        left: 0,
      }),
  width: '0 !important',
  minWidth: 0,
  padding: 0,
  zIndex: 2,
  overflow: 'visible',
});

export const actionsContainer: CSSFunction<{
  isCall: boolean;
}> = ({ cssProps }) => ({
  position: 'absolute',
  top: 0,
  height: '100%',
  ...(cssProps.isCall
    ? {
        right: 0,
      }
    : {
        left: 0,
      }),
  display: 'none',
});
export const buttonsContainer: CSSFunction<{
  atm: boolean;
  isDarkTheme: boolean;
}> = ({ cssProps, theme }) => {
  const { atm, isDarkTheme } = cssProps;
  const atmColor = isDarkTheme
    ? theme.colors.interactive.tan.hover
    : theme.colors.interactive.ui2.hover;
  return {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '6px 8px',
    gap: '4px',
    height: '100%',
    backgroundColor: color(
      theme,
      atm ? atmColor : theme.colors.interactive.row.hover,
    ),
    borderTop: `${color(theme, theme.colors.ui3)} solid 0.5px`,
    borderBottom: `${color(theme, theme.colors.ui3)} solid 0.5px`,
  };
};

export const buyIcon: CSSFunction = ({ theme }) => ({
  color: `${color(theme, theme.colors.interactive.buy.default)} !important`,
});

export const sellIcon: CSSFunction = ({ theme }) => ({
  color: `${color(theme, theme.colors.interactive.sell.default)} !important`,
});

export const chartIcon: CSSFunction = ({ theme }) => ({
  color: `${color(theme, theme.colors.text[1])} !important`,
  width: '16px',
  height: '16px',
});

export const buyButton: CSSFunction = ({ theme }) => ({
  padding: '2px',
  justifyContent: 'center',
  borderRadius: '4px',
  width: '24px',
  height: '24px',
  color: `${color(theme, theme.colors.interactive.buy.default)} !important`,
  border: `${color(theme, theme.colors.interactive.buy.default)} solid 1px`,
  cursor: 'pointer',
  '&:hover': {
    background: color(theme, theme.colors.interactive.buy.default),
    '> svg': {
      color: `${color(theme, theme.colors.icon3)} !important`,
    },
  },
});

export const sellButton: CSSFunction = ({ theme }) => ({
  padding: '2px',
  justifyContent: 'center',
  borderRadius: '4px',
  width: '24px',
  height: '24px',
  color: `${color(theme, theme.colors.interactive.sell.default)} !important`,
  border: `${color(theme, theme.colors.interactive.sell.default)} solid 1px`,
  cursor: 'pointer',
  '&:hover': {
    background: color(theme, theme.colors.interactive.sell.default),
    '> svg': {
      color: `${color(theme, theme.colors.icon3)} !important`,
    },
  },
});

export const chartButton: CSSFunction = ({ theme }) => ({
  padding: '4px',
  justifyContent: 'center',
  borderRadius: '4px',
  width: '24px',
  height: '24px',
  cursor: 'pointer',
  '&:hover': {
    borderRadius: '4px',
    border: `${color(theme, theme.colors.interactive.ui.active)} 1px solid`,
    background: color(theme, theme.colors.background.default),
  },
});
